import { createAction, props } from '@ngrx/store';
import { PackageUser } from 'src/app/features/package-users';

export const AttemptSigningRoomConnection = createAction(
  '[Signing Room] Attempt Signing Room Connection'
);

export const StartAttemptPreSignCompletion = createAction(
  '[Signing Room] Start Attempt Pre Sign Completion'
);

export const CancelAttemptPreSignCompletion = createAction(
  '[Signing Room] Cancel Attempt Pre Sign Completion'
);

export const AttemptPreSignCompletion = createAction('[Signing Room] Attempt Pre Sign Completion');

export const SigningSessionCompleted = createAction('[Signing Room] Signing Session Complete');

export const SigningSessionJoined = createAction('[Signing Room] Signing Session Joined');

export const SigningSessionJoinedSuccessful = createAction(
  '[Signing Room] Signing Session Joined Successful'
);

export const SigningSessionStarted = createAction('[Signing Room] Signing Session Started');

export const InitiateCompleteSigningRoomSession = createAction(
  '[Signing Room] Initates Complete Ron Signing Room Session'
);

export const CompleteSigningRoomSession = createAction(
  '[Signing Room] Completes Signing Room Package Session'
);

export const CompleteRonSigningRoomSession = createAction(
  '[Signing Room] Completes Ron Signing Room Session'
);

export const OpenSigningCompletionModal = createAction(
  '[Signing Room] Open Signing Complete Modal'
);

export const OpenAddUserToSessionModal = createAction(
  'Signing Room] Open Add User To Session Modal'
);

export const ContinueAddUserToThisSession = createAction(
  '[Signing Room] Continue Add User to this Session',
  props<{ payload: { packageUserGuid: string } }>()
);

export const PromptUserForAuthentication = createAction(
  '[Signing Room] Prompt User For Authentication',
  props<{ payload: { participant: PackageUser } }>()
);

export const ReviewDocuments = createAction('[Signing Room] Review Documents');

export const ExitSigningRoom = createAction('[Signing Room] Exit Signing Room');

export const SetShowCongratulationsPage = createAction(
  '[Signing Room] Update Show Congratulations Page',
  props<{ payload: { showCongratulations: boolean } }>()
);

export const GetSigningStartedStatus = createAction('[Signing Room] get Signing Started Status');

export const SetSigningStartedStatus = createAction(
  '[Signing Room] Set Signing Started Status',
  props<{ payload: { hasSigningStarted: boolean } }>()
);

export const SendDisruptionNotificationToSigningAgent = createAction(
  '[Signing Room] Send Disruption Notification To Signing Agent',
  props<{ payload: { title: string; message: string } }>()
);
